var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5894_14299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99915 3.22656C8.99593 3.22656 8.18005 4.04244 8.18005 5.04565C8.18005 6.04886 8.99593 6.8647 9.99915 6.8647C11.0024 6.8647 11.8182 6.04882 11.8182 5.04565C11.8182 4.04248 11.0023 3.22656 9.99915 3.22656ZM9.99915 5.95562C9.49754 5.95562 9.08917 5.54726 9.08917 5.04565C9.08917 4.54405 9.49754 4.13568 9.99915 4.13568C10.5008 4.13568 10.9091 4.54405 10.9091 5.04565C10.9091 5.54726 10.5008 5.95562 9.99915 5.95562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5455 8.68182C19.7967 8.68182 20 8.47974 20 8.22853V6.41055C20 6.25032 19.9157 6.10164 19.7776 6.01995L10.886 0.739522C10.882 0.736838 10.878 0.734622 10.874 0.732406C10.3214 0.426141 9.69814 0.416851 9.11353 0.738627L0.222401 6.01995C0.0843324 6.1016 0 6.25032 0 6.41055V8.22853C0 8.47974 0.20331 8.68182 0.45456 8.68182H1.8182V16.864C0.815412 16.864 0 17.6793 0 18.682V20.0455C0 20.2967 0.20331 20.5 0.45456 20.5H19.5455C19.7967 20.5 20 20.2968 20 20.0455V18.682C20 17.6793 19.1846 16.864 18.1818 16.864V8.68182H19.5455ZM19.0909 18.6818V19.5909H0.909077V18.6818C0.909077 18.1807 1.31702 17.7728 1.81815 17.7728H2.27271H17.7273H18.1818C18.683 17.7727 19.0909 18.1807 19.0909 18.6818ZM2.72727 16.8636V8.68182H4.54547V16.8636H2.72727ZM5.45455 16.8636V8.68182H8.18182V16.8636H5.45455ZM9.0909 16.8636V8.68182H10.9091V16.8636H9.0909ZM11.8182 16.8636V8.68182H14.5454V16.8636H11.8182ZM15.4546 16.8636V8.68182H17.2728V16.8636H15.4546ZM0.909077 7.77274V6.66789L9.56455 1.52583C9.84776 1.37003 10.1487 1.37046 10.4284 1.52272L19.0909 6.66789V7.77274H0.909077Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5894_14299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankInfo);
export default __webpack_public_path__ + "static/media/bankInfo.6cb69bc8b2356167287bc8d80e299d5f.svg";
export { ForwardRef as ReactComponent };